import { useCallback, useRef, useState } from 'react'
import config from 'config'
import { useLoadFrillWidgetScript } from 'util/hooks/frillWidget'

const { frillWidgets } = config

const useFrillNotification = () => {
  const widgetRef = useRef()
  const [loaded, setLoaded] = useState(false)
  const handleLoadedFrillScript = useCallback(() => {
    widgetRef.current = window.Frill.widget({
      key: frillWidgets.roadmap.key,
    })
    setLoaded(true)
  }, [])
  const onNotify = useCallback(slug => {
    if (!widgetRef.current) return
    widgetRef.current.onNotification({
      message: {
        type: 'notification',
        payload: {
          options: {
            type: 'modal',
            announcementSlug: slug,
          },
        },
      },
    })
  }, [])
  useLoadFrillWidgetScript(handleLoadedFrillScript)

  return { onNotify, loaded }
}

export default useFrillNotification
